export enum ComparisonOperator {
  CONTAINS = 'CONTAINS',
  HAS_VALUE = 'HAS_VALUE',
  EQUALS = 'EQUALS',
  IN_THE_LAST = 'IN_THE_LAST',
  IN_THE_NEXT = 'IN_THE_NEXT',
  MORE_THAN_AGO = 'MORE_THAN_AGO',
  STARTS_WITH = 'STARTS_WITH',
  ENDS_WITH = 'ENDS_WITH',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_EQUALS = 'GREATER_THAN_EQUALS',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_EQUALS = 'LESS_THAN_EQUALS',
  MULTIPLE_OF = 'MULTIPLE_OF',
}

export enum LogicalOperator {
  AND = 'AND',
  NOT = 'NOT',
  OR = 'OR',
}
